import axios from "axios";
import { GlobalConfig } from './Config';
import { useStore } from "./Store";


export const GetgameLink = async (username: string) => {
    try {
        const response = await axios.get(`${GlobalConfig.URL}/member/launch-game?username=${username}`, {
            headers: {
                Authorization: `Bearer ${useStore.getState().accessToken}`
              }
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};


export const RefreshToken = async (username: string) => {
    try {
        const response = await axios.get(`https://sport-api-ufa.lnwthai.com/member/refresh-token?username=${username}`, {
            headers: {
                Authorization: `Bearer ${useStore.getState().accessToken}`
              }
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};